export default __webpack_public_path__ + "sunrise-667ca44acc9df50223c0ed279cb6e3f6.svg";